module.exports = __webpack_public_path__ + "static/media/next-coast.4e5b5eaf.svg";